import React from 'react';
import { Col, Container, Row } from 'reactstrap';
import Wizard from './Wizard/Wizard';
import {withTranslation} from "react-i18next";

const CreatePage = ({t}) => (
  <Container className="dashboard">
    <Row>
      <Col md={12}>
        <h3 className="page-title">{t('create.title')}</h3>
      </Col>
    </Row>
    <Row>
      <Col md={12}>
        <Wizard />
      </Col>
    </Row>
  </Container>
);

export default withTranslation('dashboard')(CreatePage);
